import getTypes from './types';
// import getSelectors, { _getDataField } from './selectors';

export const initialState = state => ({
    ...state,
    districtsRelations: {},
    neighborhoodsRelations: {},
    cityReferredToCurrentDistricts: null,
    districtReferredToCurrentNeighborhoods: null,
});

const createReducer = storeName => {
    const types = getTypes(storeName);
    return (state = initialState({}), action) => {
        const { type, payload } = action;
        switch (type) {
            case types.SAVE_DISTRICTS_BY_CITY: {
                const { cityName, districtList } = payload;
                return {
                    ...state,
                    districtsRelations: {
                        ...state.districtsRelations,
                        [cityName]: districtList,
                    },
                };
            }

            case types.SET_CITY_REFERRED_TO_CURRENT_DISTRICTS: {
                return {
                    ...state,
                    cityReferredToCurrentDistricts: payload.city,
                };
            }

            case types.SET_FAKE_VALIDATION: {
                const { name, validations = {} } = action.payload;
                return {
                    ...state,
                    data: {
                        ...state.data,
                        [name]: {
                            ...state.data[name],
                            required: validations.required,
                            value: validations.value,
                            constraints: validations.constraints,
                            initialConstraints: validations.constraints,
                        },
                    },
                };
            }

            case types.SAVE_NEIGHBORHOODS_BY_DISTRICT: {
                const { districtName, neighborhoodList } = payload;
                return {
                    ...state,
                    neighborhoodsRelations: {
                        ...state.neighborhoodsRelations,
                        [districtName]: neighborhoodList,
                    },
                };
            }

            case types.SET_DISTRICT_REFERRED_TO_CURRENT_NEIGHBORHOODS: {
                return {
                    ...state,
                    districtReferredToCurrentNeighborhoods: payload.district,
                };
            }

            default:
                return state;
        }
    };
};

export default createReducer;
